import { FC } from 'react';
import { Route, Switch } from 'react-router-dom';
import EntranceSchedule from '../pages/entrance/schedule';
import EntranceScheduleExaminee from '../pages/entrance/schedule/examinee';
import EntranceScheduleExamineeDetail from '../pages/entrance/schedule/examinee/detail';

const EntranceRouter: FC = () => {
  return (
    <Switch>
      <Route path='/entrance/schedule' exact component={EntranceSchedule} />
      <Route path='/entrance/schedule/:platScheduleCode/examinee' exact component={EntranceScheduleExaminee} />
      <Route path='/entrance/schedule/:platScheduleCode/examinee/:platRequireCode' exact component={EntranceScheduleExamineeDetail} />
    </Switch>
  )
}

export default EntranceRouter;
